import * as React from "react";

function SvgVariance(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 81 81"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        d="M0 0h20.06c-.29 9.99-.03 20-.14 30 .04 2.99-.17 6.34.73 9.21.96 2.96 3.09 4.81 5.19 6.95 4.83 4.76 9.54 9.63 14.42 14.34 5.51-5.57 11.13-11.05 16.6-16.66 2.47-2.59 3.62-5.19 3.57-8.83.03-11.67-.04-23.34.03-35.01h19.96c.03 13 .03 26.01.01 39.01-.04 6.47-2.76 12.54-7.4 17.01-8.27 8.16-16.32 16.56-24.73 24.55-5.43-.13-10.87-.02-16.31-.08C23.68 72.31 15.49 64 7.21 55.78 2.97 51.66.64 46.35 0 40.5V0z"
        fill="#cda176"
      />
    </svg>
  );
}

export default React.forwardRef(SvgVariance);
